import backend from 'network/BackendFetchAdapter';
import { Token } from 'types/security/token';
import { AgentForm } from 'types/forms/AgentForm';

export const userApi = {
  updatePassword: (passwordData: AgentForm): Promise<Token> => backend.post('/api/users/password', passwordData),
};
